@if (type$ | async; as type) {
	@if (form) {
		<form class="c-main-filter" [formGroup]="form">
			<div class="flex--1">
				@if (type === OffersType.DAYTRIP) {
					<tvcore-dropdown
						name="location"
						[label]="'HOME.MAIN_FILTERS.WHERE' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_OPTION' | translate"
						[options]="locations$ | async"
						[searchable]="['name', 'data.postalCode']"
						[searchablePlaceholder]="'HOME.MAIN_FILTERS.SEARCH' | translate"
						[hideOptional]="true"
						[showClear]="true"
						(searching)="searchLocationName($event)"
					>
						<ng-template #extraOptionsTemplate>
							@if (offersAsOptions().length) {
								<p class="c-dropdown__subtitle">{{ 'HOME.MAIN_FILTERS.' + type | translate }}</p>

								@for (offer of offersAsOptions(); track offer.id) {
									<a class="c-dropdown__item" [routerLink]="['/', 'offers', offer.id]">
										{{ offer.name }}
									</a>
								}

								<p class="c-dropdown__subtitle">{{ 'HOME.MAIN_FILTERS.LOCATIONS' | translate }}</p>
							}
						</ng-template>

						<ng-template #selectedTemplate let-option>{{ option.name }}</ng-template>

						<ng-template #optionTemplate let-option>
							{{ option.name }}

							@switch (option.type) {
								@case (LocationType.CITY) {
									@if (option.data.postalCode) {
										<span>({{ option.data.postalCode }})</span>
									}
								}
								@case (LocationType.PROVINCE) {
									<span>({{ 'PROVINCE.PROVINCE' | translate }})</span>
								}
								@case (LocationType.REGION) {
									<span>({{ 'REGION.REGION' | translate }})</span>
								}
							}
						</ng-template>
					</tvcore-dropdown>
				} @else if (type === OffersType.ACCOMMODATION) {
					<tvcore-dropdown
						name="location"
						[label]="'HOME.MAIN_FILTERS.WHERE' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_OPTION' | translate"
						[options]="locations$ | async"
						[searchable]="['name', 'data.postalCode']"
						[searchablePlaceholder]="'HOME.MAIN_FILTERS.SEARCH' | translate"
						[hideOptional]="true"
						[showClear]="true"
						(searching)="searchLocationName($event)"
					>
						<ng-template #extraOptionsTemplate>
							@if (offersAsOptions().length) {
								<p class="c-dropdown__subtitle">{{ 'HOME.MAIN_FILTERS.' + type | translate }}</p>

								@for (offer of offersAsOptions(); track offer.id) {
									<a class="c-dropdown__item" [routerLink]="['/', 'offers', offer.id]">
										{{ offer.name }}
									</a>
								}

								<p class="c-dropdown__subtitle">{{ 'HOME.MAIN_FILTERS.LOCATIONS' | translate }}</p>
							}
						</ng-template>

						<ng-template #selectedTemplate let-option>{{ option.name }}</ng-template>

						<ng-template #optionTemplate let-option>
							{{ option.name }}

							@switch (option.type) {
								@case (LocationType.CITY) {
									@if (option.data.postalCode) {
										<span>({{ option.data.postalCode }})</span>
									}
								}
								@case (LocationType.PROVINCE) {
									<span>({{ 'PROVINCE.PROVINCE' | translate }})</span>
								}
								@case (LocationType.REGION) {
									<span>({{ 'REGION.REGION' | translate }})</span>
								}
							}
						</ng-template>
					</tvcore-dropdown>
				} @else {
					<tvcore-dropdown
						name="targetAudiences"
						[label]="'HOME.MAIN_FILTERS.TARGET_AUDIENCE' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_MULTIPLE_OPTION' | translate"
						[options]="TARGET_AUDIENCES"
						[multi]="true"
						[hideOptional]="true"
					>
						<ng-template #optionTemplate let-option>{{ 'TARGET_AUDIENCE.' + option | translate }}</ng-template>
					</tvcore-dropdown>
				}
			</div>

			<div class="flex--1">
				@if (type === OffersType.DAYTRIP) {
					<tvcore-dropdown
						name="productTypes"
						[label]="'HOME.MAIN_FILTERS.WHAT' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_MULTIPLE_OPTION' | translate"
						[options]="PRODUCT_TYPES_DAYTRIP"
						[multi]="true"
						[hideOptional]="true"
					>
						<ng-template #optionTemplate let-option>{{ 'PRODUCT_TYPE.' + option | translate }}</ng-template>
					</tvcore-dropdown>
				} @else if (type === OffersType.ACCOMMODATION) {
					<tvcore-dropdown
						name="productTypes"
						[label]="'HOME.MAIN_FILTERS.LOGIE' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_MULTIPLE_OPTION' | translate"
						[options]="PRODUCT_TYPES_ACCOMMODATION"
						[multi]="true"
						[hideOptional]="true"
					>
						<ng-template #optionTemplate let-option>{{ 'PRODUCT_TYPE.' + option | translate }}</ng-template>
					</tvcore-dropdown>
				} @else {
					<tvcore-dropdown
						name="periods"
						[label]="'HOME.MAIN_FILTERS.PERIOD' | translate"
						[placeholder]="'HOME.MAIN_FILTERS.SELECT_MULTIPLE_OPTION' | translate"
						[options]="PERIODS"
						[multi]="true"
						[hideOptional]="true"
					>
						<ng-template #optionTemplate let-option>{{ 'PERIOD.' + option | translate }}</ng-template>
					</tvcore-dropdown>
				}
			</div>

			<button class="c-btn c-btn--blue" (click)="applyFilters()">
				<tvcore-icon name="search"></tvcore-icon>
				{{ 'HOME.MAIN_FILTERS.APPLY_BUTTON' | translate }}
			</button>
		</form>
	}
}
